import React from 'react';
import { btnSecondary } from './adminUi';
import { useAdminPermissions } from './adminPermissions';

export function AdminAnalystPreviewToggle() {
  const { previewAsAnalyst, canToggleAnalystPreview, setPreviewAsAnalyst } = useAdminPermissions();

  if (!canToggleAnalystPreview) return null;

  return (
    <button
      type="button"
      className={`${btnSecondary} h-9 gap-2 px-3 text-xs ${previewAsAnalyst ? 'border-amber-300 bg-amber-50 text-amber-900' : ''}`}
      onClick={() => setPreviewAsAnalyst(!previewAsAnalyst)}
      title="Посмотреть админ-панель глазами аналитика без смены роли в БД"
    >
      <i className={`fas ${previewAsAnalyst ? 'fa-user-check' : 'fa-user'}`} aria-hidden="true" />
      {previewAsAnalyst ? 'Режим analyst' : 'Как analyst'}
    </button>
  );
}

export function AdminAnalystPreviewBanner() {
  const { previewAsAnalyst, canToggleAnalystPreview, setPreviewAsAnalyst } = useAdminPermissions();

  if (!canToggleAnalystPreview || !previewAsAnalyst) return null;

  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950">
      <div>
        <p className="font-medium">Режим просмотра: analyst</p>
        <p className="mt-0.5 text-amber-800">
          Интерфейс ограничен как у роли analyst. В БД у вас по-прежнему admin.
        </p>
      </div>
      <button
        type="button"
        className={btnSecondary}
        onClick={() => setPreviewAsAnalyst(false)}
      >
        Выйти из режима
      </button>
    </div>
  );
}
